import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Landmark, Plus } from 'lucide-react';
import { Sidebar, Topbar } from './Dashboard';
import { Button } from '../components/ui/button';
import { auth, clients, clientService, getStoredUser } from '../api';
import { SarsDialog, SarsTable, useSarsActions } from '../components/client/Sars';

const FILTERS = [{ key: 'open', label: 'Open' }, { key: 'responded', label: 'Responded' }, { key: 'closed', label: 'Closed' }, { key: '', label: 'All' }];

export default function SarsPage() {
  const nav = useNavigate();
  const [user, setUser] = useState(getStoredUser());
  const [items, setItems] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [filter, setFilter] = useState('open');
  const load = () => clientService.sarsAll(filter).then(setItems);
  const { dialog, setDialog, remove, openNew, openEdit } = useSarsActions(load);

  useEffect(() => {
    if (!localStorage.getItem('ad_token')) { nav('/login'); return; }
    Promise.all([auth.me().catch(() => null), clients.list()]).then(([me, cl]) => { if (me) setUser(me); setClientList(cl); });
    // eslint-disable-next-line
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [filter]);

  return (
    <div className="min-h-screen bg-stone-50 flex">
      <Sidebar activeLabel="SARS"/>
      <div className="flex-1 min-w-0">
        <Topbar user={user} firm={user?.firm}/>
        <main className="p-4 lg:p-8 space-y-6">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl lg:text-3xl font-serif font-semibold text-stone-900 flex items-center gap-2"><Landmark size={24} className="text-emerald-800"/> SARS correspondence</h1>
              <p className="mt-1 text-stone-600 text-sm">Every letter, verification, audit and objection across your clients, sorted by response deadline.</p>
            </div>
            <Button onClick={openNew} className="bg-emerald-800 hover:bg-emerald-900 text-white" data-testid="sars-page-new-btn"><Plus size={16} className="mr-2"/> Log correspondence</Button>
          </div>
          <div className="inline-flex rounded-lg border border-stone-200 bg-white p-1" data-testid="sars-filters">
            {FILTERS.map((f) => (
              <button key={f.label} type="button" onClick={() => setFilter(f.key)} data-testid={`sars-filter-${f.label.toLowerCase()}`}
                className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${filter === f.key ? 'bg-emerald-800 text-white' : 'text-stone-600 hover:text-stone-900'}`}>{f.label}</button>
            ))}
          </div>
          <div className="rounded-xl bg-white border border-stone-200 overflow-hidden">
            <SarsTable items={items} showClient onEdit={openEdit} onDelete={remove}/>
          </div>
        </main>
      </div>
      <SarsDialog open={dialog.open} onOpenChange={(o) => setDialog({ ...dialog, open: o })} item={dialog.item} clients={clientList} onSaved={load}/>
    </div>
  );
}
